"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

var _icon = _interopRequireDefault(require("../views/icon.c"));

var _checkedIcon = _interopRequireDefault(require("../views/checkedIcon.c"));

var _IconButton = _interopRequireDefault(require("../../IconButton"));

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Root = _createStyled["default"].div(_templateObject()),
    Label = _createStyled["default"].div(_templateObject2()),
    LabelWrapper = _createStyled["default"].div(_templateObject3()),
    LabelText = _createStyled["default"].div(_templateObject4()),
    IconWrapper = _createStyled["default"].div(_templateObject5()),
    Input = _createStyled["default"].input(_templateObject6()),
    InputLabel = _createStyled["default"].label(_templateObject7()),
    Wrapper = _createStyled["default"].div(_templateObject8());

function template() {
  var labelContent = null,
      _this$props = this.props,
      label = _this$props.label,
      disabled = _this$props.disabled,
      name = _this$props.name,
      checked = _this$props.checked,
      value = _this$props.value,
      onChange = _this$props.onChange,
      attribute = _this$props.attribute,
      _this$props$className = _this$props.className,
      className = _this$props$className === void 0 ? '' : _this$props$className,
      children = _this$props.children,
      checkedIcon = _this$props.checkedIcon,
      icon = _this$props.icon,
      _this$props$theme = _this$props.theme,
      theme = _this$props$theme === void 0 ? {} : _this$props$theme,
      id = this.props.id || this.id,
      img,
      iconContent,
      styles = this.compileStyled(_index["default"]);

  if (label) {
    labelContent = _react["default"].createElement(Label, {
      styles: styles.description
    }, label);
  }

  if (checked) {
    img = checkedIcon || theme.appearanceChecked || // TODO REMOVE. backward compatibility
    theme.appearanceActive || _react["default"].createElement(_IconButton["default"], {
      iconFx: false,
      rippleColor: theme.checkedRippleColor,
      disabled: disabled
    }, _react["default"].createElement(_checkedIcon["default"], {
      fill: theme.checkedIconColor
    }));
  } else {
    img = icon || theme.appearance || _react["default"].createElement(_IconButton["default"], {
      iconFx: true,
      rippleColor: theme.rippleColor,
      disabled: disabled
    }, _react["default"].createElement(_icon["default"], {
      fill: theme.iconColor
    }));
  }

  if (typeof img === 'string') {
    iconContent = _react["default"].createElement(_IconButton["default"], {
      icon: img,
      iconFx: !checked,
      rippleColor: checked ? theme.checkedRippleColor : theme.rippleColor,
      disabled: disabled
    });
  } else {
    iconContent = img;
  }

  return _react["default"].createElement(Root, {
    styles: styles.root,
    className: className
  }, _react["default"].createElement(Wrapper, {
    styles: styles.wrapper
  }, labelContent, _react["default"].createElement(LabelWrapper, {
    styles: styles.labelWrapper
  }, _react["default"].createElement(Input, {
    disabled: disabled,
    name: name,
    checked: !!checked,
    value: value,
    type: "radio",
    styles: styles.field,
    ref: this._createRef,
    onChange: onChange,
    id: id,
    "data-qa-node": attribute,
    "data-qa-value": value
  }), _react["default"].createElement(InputLabel, {
    styles: styles.label,
    htmlFor: id
  }, _react["default"].createElement(IconWrapper, {
    styles: styles.iconWrapper
  }, iconContent), _react["default"].createElement(LabelText, {
    styles: styles.labelText
  }, children)))));
}